/**
 * Data structure for a Game ID
 */
define('gameday-index-enums/enums/baseball/GIDDecoder',['require','exports','module'],function(require, exports, module) {
	var data,
		gid,
		gidSplit,
		year,
		month,
		day;
	
	
	function GIDDecoder($data) {
		data = $data;
		
		if (data.length == 26 || data.length == 30) {
			if (data.length == 30) {
				data = data.substr(4, 30);
			}
		} else {
			throw new Error("the game id handed over does not seem to be valid length, pardner.")
		}

		gid = ((data.split("/").join("_") ).split("-") ).join("_").substring((data.length === 26) ? 0 : 4);
		gidSplit = gid.split("_");
		year = gidSplit[0];
		month = gidSplit[1];
		day = gidSplit[2];

		return {
			gid: gid,
			gid_path: "gid_" + gid,
			year: year,
			month: month,
			day: day,
			away_full_code: gidSplit[3],
			away_team_code: gidSplit[3].substr(0,3),
			away_sport_code: gidSplit[3].substr(3,6),
			home_full_code: gidSplit[4],
			home_team_code: gidSplit[4].substr(0,3),
			home_sport_code: gidSplit[4].substr(3,6),
			product_code: gidSplit[4].substr(3,6),
			gamenumber: gidSplit[5],
			gameDateString: (function () { return month + "/" + day + "/" + year; })(),
			dateFormat: [this.month, this.day, this.away_full_code, this.home_full_code],
			isValid: (function () {
				if (data.length !== 26 && data.length !== 30) {
					return false;
				} else {
					return !(isNaN(parseFloat(this.year)) || isNaN(parseFloat(this.month)) || isNaN(parseFloat(this.day)) || isNaN(parseFloat(gidSplit[6])));
				}
			}())
		}
	}

	return GIDDecoder;
});
